import './Header.css';

export function Header() {
  return (
    <header className="header">
      <h1>Progressive Overloading Tracker</h1>
    </header>
  );
}
